<h3-button-with-popover
  popoverTitle="Calibration Settings"
  tooltipText="Calibration settings"
>
  <ng-container projection-location="button">
    <mat-icon [h3CustomIcon]="calibrationSettingsIcon"></mat-icon>
  </ng-container>
  @if (injector) {
    <h3-camera-calibration-popover
      projection-location="popover-content"
      *h3Injector="injector"
      [videoOutputName]="videoOutputName"
    ></h3-camera-calibration-popover>
  }
</h3-button-with-popover>
